import { Route } from '@angular/router';
import { LoginEnterMFACodeComponent } from '@modules/login/components/login-enter-mfa-code/login-enter-mfa-code.component';
import { LoginLayoutMainComponent } from '@modules/login/components/login-layout-main/login-layout-main.component';
import { LoginMainComponent } from '@modules/login/components/login-main/login-main.component';
import { LoginSelectMFAMethodComponent } from '@modules/login/components/login-select-mfa-method/login-select-mfa-method.component';
import { LoginRequestRouteGuard } from '@modules/login/services/login-request-route-guard';

export const LOGIN_ROUTES: Route[] = [
    {
        path: '',
        component: LoginLayoutMainComponent,
        children: [
            {
                path: '',
                component: LoginMainComponent
            },
            {
                path: 'SelectMFADevice',
                component: LoginSelectMFAMethodComponent,
                canActivate: [LoginRequestRouteGuard]
            },
            {
                path: 'EnterMFACode/:loginMFACodeId',
                component: LoginEnterMFACodeComponent,
                canActivate: [LoginRequestRouteGuard]
            },
            {
                path: 'ResetPassword',
                loadChildren: () => import('@modules/login-reset-password/login-reset-password.module').then(x => x.LoginResetPasswordModule)
            },
            {
                path: 'SignUp',
                loadChildren: () => import('@modules/login-sign-up/login-sign-up.module').then(x => x.LoginSignUpModule)
            },
            {
                path: 'RecoverEmailAddress',
                loadChildren: () => import('@modules/login-recover-email-address/login-recover-email-address.module').then(x => x.LoginRecoverEmailAddressModule)
            },
        ],
        title: 'HRally'
    }
];
